export default "__VITE_ASSET__cDQeMNeT__"